import { render } from "./SelectLabels.vue?vue&type=template&id=ade69fe8"
import script from "./SelectLabels.vue?vue&type=script&lang=js"
export * from "./SelectLabels.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__